export var SEPARATOR = '.';